<template>
  <div
    class="td"
    :title="data.title"
    :class="{
      big: data && data.className && Array.isArray(data.className) && data.className.includes('big') && data.className.includes('site'),
    }"
  >
    <span v-if="!data.entries" :class="['value-block', data.className]">
      <span v-if="data.supCaption" class="segment">
        <span class="sup-caption">{{ data.supCaption }}</span>
      </span>
      <span class="segment">
        <span v-if="data.caption" class="caption"> {{ data.caption }} </span><i v-if="data.trend" :class="`icon-${data.trend}`"></i
        ><AnimatedValue :value="data.value" :to-fixed-value="data.toFixedValue" :className="data.className" />
        <small>{{ data.sub }}<i v-if="data.icon" :class="`icon-${data.icon}`"></i></small>
      </span>
    </span>
    <span v-for="(item, idx) in data.entries" v-else :key="idx" :class="['value-block', item.className]">
      <span class="segment">
        <i v-if="item.trend" :class="`icon-${item.trend}`"></i
        ><AnimatedValue :value="item.value" :to-fixed-value="data.toFixedValue" :className="data.className" />
        <small>{{ item.sub }}<i v-if="item.icon" :class="`icon-${item.icon}`"></i></small>
      </span>
    </span>
  </div>
</template>

<script>
import AnimatedValue from '@/components/AnimatedValue';
export default {
  components: {
    AnimatedValue,
  },

  props: ['data'],
};
</script>

<style lang="scss" scoped>
@use '@/styles/colors.scss';

.td {
  max-width: 40em;
  font-weight: 300;

  &.underline {
    margin-right: -256px !important;
    margin-left: 0 !important;
    width: calc(100% + 256px);
    border-bottom: solid 1px #e3e3e3;
  }
  &.big {
    max-width: initial;
  }
  &.current-site-value {
    height: 24px;
    padding: 8px 0;
    margin: 8px 0 0;
    border-top: solid 1px #e3e3e3;
  }

  .value-block {
    flex-direction: column;
    display: flex;

    &.green {
      color: colors.$green-color;
    }
    &.orange {
      color: colors.$warning-color;
    }
    &.red {
      color: colors.$red-color;
    }
  }
  .sup-caption {
    font-size: 0.7272727273em;
    margin-top: -0.75em;
    line-height: 0.75;
    display: block;
  }
}

.tv {
  .td .current-site {
    border-top: none;
    font-size: 2em;
    margin: 8px 0 -64px;

    &.site {
      font-weight: normal !important;
    }
  }
}
</style>
